/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trip_Toast_EndedInputs */

const vi_trip_toast_ended = /** @type {(inputs: Trip_Toast_EndedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã kết thúc chuyến`)
};

/**

* @param {Trip_Toast_EndedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const trip_toast_ended = /** @type {((inputs?: Trip_Toast_EndedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trip_Toast_EndedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_trip_toast_ended(inputs)
});